import React, { forwardRef } from 'react';
import moment from 'moment-timezone';

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DatePicker from 'components/DatePicker';

interface Props {
	value?: string;
	onChange?: (value: string) => void;
	id: string;
	minDate?: string;
}

const DatePickerField = forwardRef(({ value, onChange, id, minDate }: Props, ref) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<DatePicker
			value={value}
			onChange={(value) => onChange?.(moment(value).format('YYYY-MM-DD'))}
			id={id}
			styleProps={{
				height: 35,
				bordered: true,
			}}
			singleDatePickerProps={{
				showDefaultInputIcon: !isMobile,
				isOutsideRange: (day: moment.Moment) =>
					moment(day).isBefore(moment(minDate, 'YYYY-MM-DD'), 'day'),
			}}
		/>
	);
});

export default DatePickerField;
